import { render, staticRenderFns } from "./CreateVehicleDialog.vue?vue&type=template&id=2b7e10d0&lang=pug&"
import script from "./CreateVehicleDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateVehicleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports